import Rx from "rxjs";
import { EpicFactory } from "../../../core/core-redux/reduxTypes";
import { allLayersSelector } from "../../../common/selector/layerSelector";
import { changeLayerProperties } from "../../../../MapStore2/web/client/actions/layers";
import { Action } from "redux";
import { Layer, RootState } from "../../../rootState";
import { CHANGE_MAP_CRS, ChangeMapCrs } from "../../../common/mapstore/action";
import { Projection } from "../../../common/types";

/*
    Disables Visibility Limits for all layers when switched to 3D mode.
    Workaround for MapStore bug - visibility limits not working in 3D mode.
 */
export const disableResolutionLimitsEpic: EpicFactory<Action, RootState, Action> = (action$, store) =>
    action$.ofType<ChangeMapCrs>(CHANGE_MAP_CRS).switchMap((action) => {
        const layers: Layer[] = allLayersSelector(store.getState());
        const disableResolutionLimits = action.crs === Projection.GLOBE_3D;
        return Rx.Observable.from(layers).map((layer: Layer) => {
            return changeLayerProperties(layer.id, { disableResolutionLimits: disableResolutionLimits });
        });
    });
